import React from "react";
import { Radio } from "@visma-netvisor/react-component-library";
import { CheckboxInput } from "@visma-netvisor/react-component-library/lib/components/checkbox/CheckboxInput";
import { InlineLabel } from "@visma-netvisor/react-component-library/lib/components/componentBase/InlineLabel";
import { Layout } from "@visma-netvisor/react-component-library";
import { useServiceNeedContext } from "../context/ServiceNeedContext";
import { Trans, useTranslation } from "react-i18next";

type LabeledOptionProps = {
  name: string;
  labelKey: string;
  onChange: ((e: React.ChangeEvent<HTMLInputElement>) => void);
  type: "checkbox" | "radio";
  checked?: boolean;
};

const LabeledOption: React.FC<LabeledOptionProps> = ({
  name,
  labelKey,
  onChange,
  type,
  checked: checkedProp
}) => {
  const context = useServiceNeedContext();
  const { t } = useTranslation();

  if (!(name in context)) {
    return null;
  }

  const id = `${type}_${name}`;

  const checked =
    typeof checkedProp === "boolean"
      ? checkedProp
      : context[name as keyof typeof context] === true;

  return (
    <Layout.Flex
      alignItems="center"
      flexGap={8}
      inline
      styleOverrides={{ minHeight: 32 }}
    >
      {type === "checkbox" ? (
        <>
          <CheckboxInput
            id={id}
            name={name}
            checked={checked}
            onChange={onChange}
            type={type}
          />        
          <InlineLabel htmlFor={id} variant="horizontal">
            <Trans i18nKey={labelKey} components={[<b />]} />
          </InlineLabel>
        </>
      ) : (
        <Radio
          name={name}
          checked={checked}
          onChange={onChange}
          label={t(labelKey)}
        />
      )}
    </Layout.Flex>
  );
};

export default LabeledOption;